import React from "react";

const Input = ({
    id,
    label,
    description,
    error,
    leading,
    trailing,
    className = "",
    inputClassName = "",
    ...props
}) => {
    const controlClasses = ["ui-input__control", className].filter(Boolean).join(" ");

    return (
        <label className="ui-input" htmlFor={id}>
            {label && <span className="ui-input__label">{label}</span>}
            <span className={controlClasses}>
                {leading && <span className="ui-input__icon ui-input__icon--leading">{leading}</span>}
                <input id={id} className={["ui-input__field", inputClassName].filter(Boolean).join(" ")} {...props} />
                {trailing && <span className="ui-input__icon ui-input__icon--trailing">{trailing}</span>}
            </span>
            {description && !error && (
                <span className="ui-input__description">{description}</span>
            )}
            {error && <span className="ui-input__error">{error}</span>}
        </label>
    );
};

export default Input;

